module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "timeline"
  }, [_h('h3', ["\n    Votre enfant a:", _h('br'), " ", _h('strong', [_vm._s(_vm.age)])]), " ", _h('div', {
    staticClass: "bars"
  }, [_vm._l((_vm.length), function(n) {
    return _h('div', {
      staticClass: "bar"
    }, [_h('div', {
      staticClass: "line",
      class: [n > _vm.count ? '' : 'active']
    })])
  })]), " ", _h('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/reveal"
    }
  }, [_h('h3', ["PASSER", _h('br'), "L'EXPERIENCE"])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58767764!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline.vue
// module id = 52
// module chunks = 1